export const PAGE_DEFAULT = { name: 'recom' };
